import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import "./Sidebar.scss";

const menuItems = [
    { name: "Home", to: "/" },
    { name: "Portfolio", to: "/Portfolio" },
    { name: "Services", to: "/Services" },
    { name: "About Us", to: "/About-Us" },
]

export default function Sidebar() {
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
        window.addEventListener("resize", function (event) {
            setWidth(window.innerWidth);
        });
    });
    const sidebarHide = () => {
        document.getElementById("sidebar").classList.remove("active");
        document.getElementById("navbar-toggle").classList.remove("active");
        document.body.classList.remove("fix");
    };
    const location = useLocation();

    const handleContactClick = () => {
        document.getElementById("sidebar").classList.remove("active");
        document.getElementById("navbar-toggle").classList.remove("active");
        document.body.classList.remove("fix");
        window.dispatchEvent(new Event("scrollToForm"));
    };
    return (
        <>{width <= 1080 && (<aside id='sidebar' className='off-canvas-wrapper'>
            <div className="off-canvas-overlay" onClick={sidebarHide}></div>
            <div className="off-canvas-content sidebar">
                <ul>
                    {menuItems.map((item, index) => {
                        const isActive = location.pathname === item.to;
                        return (
                            <li key={index}><Link to={item.to} className={`nav-item ${isActive ? 'active' : ''}`} onClick={sidebarHide}>{item.name}</Link></li>
                        )
                    })}
                    <li><Link className="nav-item" onClick={handleContactClick}>Contact Us</Link></li>
                </ul>
            </div>
        </aside>)}</>
    )
}
